import React, { PropsWithChildren } from 'react';
import AccountVerificationMultiStepHeader from '../../multi-step/header/AccountVerificationMultiStepHeader';

export default function AccountVerificationProofOfAddressHeader(props: PropsWithChildren<Record<string, unknown>>) {
    return <AccountVerificationMultiStepHeader {...props} />;
}
